module.exports = __webpack_public_path__ + "img/Orb_Label_Text_Logic.64cb6744.png";